<template>
 <div>
  <Header />
  <div class="serviceNetwork-content">
   <div class="serviceNetwork-content-title serviceNetwork_box">服务省份</div>
   <div class="serviceNetwork-content-didian serviceNetwork_box">内蒙古、新疆、山西、陕西、河南、云南、广东、重庆、湖南、山东、河北、呼伦贝尔</div>
   <div class="serviceNetwork-content-tuli serviceNetwork_box">

    <div>图例：</div>
    <div class="serviceNetwork-content-tuli-img">
     <img src="@/assets/image/companyProfile/zongbu.png" alt="">
     总部
    </div>
    <div class="serviceNetwork-content-tuli-img">
     <img src="@/assets/image/companyProfile/shengfen.png" alt="">
     省份
    </div>
   </div>
   <div class="serviceNetwork-content-ditu-img serviceNetwork_box">
    <img src="@/assets/image/companyProfile/ditu.gif" alt="">
   </div>
  </div>
  <div class="serviceNetwork-content-mobile">
   <div class="serviceNetwork-content-title-mobile serviceNetwork_box">
    <div class="serviceNetwork-content-title-content-mobile serviceNetwork_box">服务省份</div>
    <div>内蒙古、新疆、山西、陕西、河南、云南、广东、重庆、湖南、山东、河北、呼伦贝尔</div>
   </div>
   <div class="serviceNetwork-content-tuli-mobile  serviceNetwork_box">
    <div>图例：</div>
    <div class="serviceNetwork-content-tuli-img-mobile">
     <img src="@/assets/image/companyProfile/zongbu.png" alt="">
     <span>总部</span>
    </div>
    <!-- <div class="serviceNetwork-content-tuli-img-mobile">
     <img src="@/assets/image/companyProfile/fgs.png" alt="">

     <span>分公司</span>
    </div> -->
    <div class="serviceNetwork-content-tuli-img-mobile">
     <img src="@/assets/image/companyProfile/shengfen.png" alt="">

     <span>省份</span>
    </div>
   </div>
   <div class="serviceNetwork-content-ditu-img-mobile serviceNetwork_box">
    <img src="@/assets/image/companyProfile/ditu_mobile.gif" alt="" style="width: 100%">
   </div>
  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import Header from "./header.vue"

import ScrollReveal from 'scrollreveal'



onMounted(() => {
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".serviceNetwork_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .serviceNetwork-content {
  display: none !important;
 }

 .serviceNetwork-content-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .serviceNetwork-content {
  display: block !important;
 }

 .serviceNetwork-content-mobile {
  display: none;
 }
}

.serviceNetwork-content {
 padding-left: 18%;
 padding-right: 18%;
 font-family: 'PuHuiTi';
}

.serviceNetwork-content-mobile {
 padding: 10px;
 font-family: 'PuHuiTi';
}

.serviceNetwork-content-title-mobile {
 padding: 10px;

}

.serviceNetwork-content-title-content-mobile {
 background: url("../../../assets/image/product/Line.png") no-repeat;
 font-size: 18px;
 height: 28px;
 font-family: 'PuHuiTi';
 background-position: 0px 15px;
 margin-bottom: 10px;
 padding-left: 6px;
}


.serviceNetwork-content-title {
 padding-left: 10px;
 margin: 30px 0;
 background: url("../../../assets/image/product/Line.png") no-repeat;
 background-position: 0px 18px;
 color: rgba(51, 51, 51, 1);
 font-size: 24px;
}

.serviceNetwork-content-didian {
 margin-bottom: 30px;
}

.serviceNetwork-content-tuli {
 display: flex;
 font-size: 18px;
 margin-bottom: 30px;

}

.serviceNetwork-content-tuli-img {
 margin-left: 20px;
}

.serviceNetwork-content-ditu-img {
 width: 100%;
 padding-bottom: 30px;
 display: flex;
 justify-content: center;
 align-items: center
}

.serviceNetwork-content-tuli-mobile {
 display: flex;
 justify-content: center;
}

.serviceNetwork-content-tuli-img-mobile {
 display: flex;
 margin: 0 10px;

 img {
  margin-right: 5px;
 }
}

.serviceNetwork-content-ditu-img-mobile {
 margin-top: 50px;
 margin-bottom: 30px;

}
</style>